import React from "react"
import CustomReactTable from "components/Templates/CustomReactTable"
import TimeCell from "components/Templates/table/TimeCell"
import { useApprovalRequestsList } from "graphql/stock-take/stock-take.hooks"
import { Icon } from "@blueprintjs/core"
import StyledLink from "components/Atoms/StyledLink"
import { useSearchFilter } from "hooks/searchFilterHooks"

const ApprovalList = () => {
  const [{ date, type }] = useSearchFilter()
  const { data, loading } = useApprovalRequestsList()

  const COLUMNS = [
    {
      Header: "Requested at",
      accessor: "requestedAt",
      Cell({ value }) {
        return <TimeCell timeStamp={value} />
      },
    },
    {
      Header: "Stock take at",
      accessor: "distributionCentre",
      Cell({ value, original }) {
        return (
          <StyledLink
            to={`/d/ecom/approval-stock-take/${value?.id}?type=${
              type || "sellable-item"
            }&date=${date}`}
          >
            {value?.name}
          </StyledLink>
        )
      },
    },
    {
      Header: "Requested by",
      accessor: "requestedBy",
      Cell({ value }) {
        return (
          <div>{`${value?.first_name || ""} ${value?.last_name || ""}`}</div>
        )
      },
    },
    {
      Header: "Total",
      accessor: "totalRequests",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Approved",
      accessor: "approvedRequests",
      Cell({ value, original }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Rejected",
      accessor: "rejectedRequests",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },
    {
      Header: "Pending",
      accessor: "pendingRequests",
      Cell({ value }) {
        return <div>{value}</div>
      },
    },

    {
      Header: "Status",
      accessor: "totalRequests",
      Cell({ value, original }) {
        if (value === 0) return <Icon icon="delete" intent="danger" />
        if (value === original?.approvedRequests)
          return <Icon icon="tick-circle" intent="success" />
        if (value === original?.pendingRequests)
          return <Icon icon="warning-sign" intent="none" />
        else return <Icon icon="tick-circle" intent="warning" />
      },
    },
  ]
  return (
    <CustomReactTable
      loading={loading}
      loadingText="Fetching data"
      data={data?.aggregateStockTakeApprovalRequestsByDc ?? []}
      columns={COLUMNS}
    />
  )
}

export default ApprovalList
